<template>
  <el-radio-group v-model="radioValue" v-if="type === 'radio'" @change="radioChange">
    <el-radio
      class="mb-10px"
      :disabled="disabled"
      :label="words[index]"
      v-for="(item, index) in options"
      :key="index"
      >{{ words[index] }}、{{ item.content }}</el-radio
    >
  </el-radio-group>
  <el-radio-group v-model="radioValue" v-else-if="type === 'judge'" @change="radioChange">
    <el-radio
      class="mb-10px"
      :disabled="disabled"
      :label="words[index]"
      v-for="(item, index) in options"
      :key="index"
      >{{ item.content }}</el-radio
    >
  </el-radio-group>
  <el-checkbox-group
    v-model="checkboxValue"
    v-else-if="type === 'checkbox'"
    @change="checkboxChange"
  >
    <el-checkbox
      class="mb-10px"
      :disabled="disabled"
      :label="words[index]"
      v-for="(item, index) in options"
      :key="index"
      >{{ words[index] }}、{{ item.content }}</el-checkbox
    >
  </el-checkbox-group>
</template>

<script type="text/babel">
import { wordsList } from '@/components/safety/enumField/enumTagType'

export default {
  name: 'multiple-exam-select',
  components: {},
  props: {
    // 单选或者多选
    type: {
      type: String,
      default: 'checkbox',
    },
    // 是否禁用选择按钮
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      default: '',
    },
    optionsString: {
      type: String,
      default: '',
    },
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  data() {
    return {
      words: wordsList,
      checkboxValue: [],
      radioValue: '',
      options: [],
    }
  },
  computed: {},
  watch: {
    value: {
      handler(value) {
        if (value) {
          switch (this.type) {
            case 'radio':
              this.radioValue = value
              break
            case 'checkbox':
              this.checkboxValue = value.split(',')
              break
            default:
              break
          }
        }
      },
      immediate: true,
    },
    optionsString: {
      handler(optionsString) {
        if (optionsString) {
          this.options = JSON.parse(optionsString)
        }
      },
      immediate: true,
    },
  },
  methods: {
    checkboxChange(values) {
      const string = values
        .filter((i) => {
          return i !== ''
        })
        .sort()
        .join()
      this.$emit('change', string)
    },
    radioChange(value) {
      this.$emit('change', value)
    },
  },
  created() {},
  mounted() {},
}
</script>

<style scoped lang="scss">
::v-deep .el-radio,
.el-checkbox {
  white-space: normal !important;
}
</style>
